import { NavLink } from "react-router-dom";

const items = [
  { label: "首页", to: "/", icon: "ri-home-5-line" },
  { label: "资讯", to: "/news", icon: "ri-newspaper-line" },
  { label: "原创", to: "/original", icon: "ri-quill-pen-line" },
  { label: "视频", to: "/video", icon: "ri-play-circle-line" },
  { label: "社区", to: "/community", icon: "ri-chat-smile-2-line" },
];

export default function MobileTabBar() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-background-200 bg-background-50/95 backdrop-blur lg:hidden">
      <div className="grid grid-cols-5">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `flex cursor-pointer flex-col items-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${
                isActive ? "text-primary-600" : "text-foreground-500"
              }`
            }
          >
            <span className="flex h-6 w-6 items-center justify-center">
              <i className={`${item.icon} text-xl`}></i>
            </span>
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}